import getCinemaData from "./getCinemaData"
import getNewsletterStylesData from "./getNewsletterStylesData"
import getStructureData from "./getStructureData"

const getNewsletterData = (
    logoData,
    campaign,
    themeData,
    cinemasData,
    addressData,
    translation,
    week,
    weeks,
    routesData
) => {
    const cinemaData = getCinemaData(logoData, campaign, cinemasData, addressData, translation, week, weeks, routesData)
    const stylesData = getNewsletterStylesData(campaign && campaign.style ? campaign.style : false, themeData)
    const structureData = getStructureData(campaign)

    return ({
        cinemaData: cinemaData,
        stylesData: stylesData,
        structureData: structureData,
        theme: stylesData.theme_colors
    })
}

export default getNewsletterData